import { render } from "./AboutView.vue?vue&type=template&id=70d5859f"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=70d5859f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__